import { render, staticRenderFns } from "./TabList.vue?vue&type=template&id=287b8e23&"
import script from "./TabList.vue?vue&type=script&lang=ts&"
export * from "./TabList.vue?vue&type=script&lang=ts&"
import style0 from "./TabList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports